import { useState } from "react";

export function useDocumentsData(supabase, landlordId, reload) {
  const [savedDocs, setSavedDocs] = useState([]);
  const [customTemplates, setCustomTemplates] = useState([]);
  const [docsTab, setDocsTab] = useState("templates");
  const [showDocModal, setShowDocModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [docTenant, setDocTenant] = useState("");
  const [docExtras, setDocExtras] = useState({});
  const [docBody, setDocBody] = useState("");
  const [docSubject, setDocSubject] = useState("");
  const [docSaved, setDocSaved] = useState(false);
  const [viewSavedDoc, setViewSavedDoc] = useState(null);
  const [showNewTemplate, setShowNewTemplate] = useState(false);
  const [newTemplate, setNewTemplate] = useState({ name: "", icon: "📄", subject: "", body: "" });
  const [editTemplate, setEditTemplate] = useState(null);

  const saveDocument = async () => {
    if (!docTenant || !docBody) return;
    const { error } = await supabase.from("documents").insert([{
      tenant: docTenant, template: selectedTemplate?.name || "Custom",
      subject: docSubject, body: docBody,
      date: new Date().toISOString().slice(0, 10), user_id: landlordId,
    }]);
    if (error) { alert("Error saving: " + error.message); return; }
    setDocSaved(true);
    setTimeout(() => setDocSaved(false), 3000);
    reload();
  };

  const deleteDocument = async (id) => {
    if (!window.confirm("Delete this saved document?")) return;
    await supabase.from("documents").delete().eq("id", id);
    reload();
  };

  const saveCustomTemplate = async () => {
    if (!newTemplate.name || !newTemplate.body) return;
    setShowNewTemplate(false);
    const { error } = await supabase.from("letter_templates").insert([{ ...newTemplate, user_id: landlordId }]);
    if (error) { alert("Error: " + error.message); return; }
    setNewTemplate({ name: "", icon: "📄", subject: "", body: "" });
    reload();
  };

  const updateCustomTemplate = async () => {
    if (!editTemplate.name || !editTemplate.body) return;
    const { error } = await supabase.from("letter_templates").update({
      name: editTemplate.name, icon: editTemplate.icon,
      subject: editTemplate.subject, body: editTemplate.body,
    }).eq("id", editTemplate.id);
    if (error) { alert("Error: " + error.message); return; }
    setEditTemplate(null);
    reload();
  };

  const deleteCustomTemplate = async (id) => {
    if (!window.confirm("Delete this template?")) return;
    await supabase.from("letter_templates").delete().eq("id", id);
    reload();
  };

  const openDocModal = (tmpl, isCustom = false) => {
    setSelectedTemplate(tmpl);
    setDocTenant("");
    setDocExtras({});
    setDocBody(isCustom ? tmpl.body : "");
    setDocSubject(tmpl.subject || "");
    setDocSaved(false);
    setShowDocModal(true);
  };

  return {
    savedDocs, setSavedDocs,
    customTemplates, setCustomTemplates,
    docsTab, setDocsTab,
    showDocModal, setShowDocModal,
    selectedTemplate,
    docTenant, setDocTenant,
    docExtras, setDocExtras,
    docBody, setDocBody,
    docSubject, setDocSubject,
    docSaved,
    viewSavedDoc, setViewSavedDoc,
    showNewTemplate, setShowNewTemplate,
    newTemplate, setNewTemplate,
    editTemplate, setEditTemplate,
    saveDocument, deleteDocument, saveCustomTemplate, updateCustomTemplate, deleteCustomTemplate, openDocModal,
  };
}
